import React from "react";
import { ToastContainer } from "react-toastify";
import UpdateTagCollection from "../../components/ProductManager/TagCollection/UpdateTagCollection";

export const UpdateTagCollectionPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <UpdateTagCollection />
        </div>
      </div>
    </div>
  );
};
